import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { Breadcrumbs, Link } from '@mui/material';

export type LayoutBreadcrumbItem = {
  label: string;
  path: string;
  active: boolean;
  icon?: React.ReactNode;
};

export interface LayoutBreadcrumbsProps {
  items: LayoutBreadcrumbItem[];
  density?: 'default' | 'quiet';
}

const LayoutBreadcrumbs: React.FC<LayoutBreadcrumbsProps> = ({
  items,
  density = 'default',
}) => {
  const navigate = useNavigate();
  const isQuiet = density === 'quiet';

  return (
    <Breadcrumbs
      separator={
        <NavigateNextIcon
          fontSize="small"
          sx={isQuiet ? { fontSize: 14 } : undefined}
        />
      }
      sx={{
        '& .MuiBreadcrumbs-separator': {
          color: 'text.secondary',
          ...(isQuiet && { mx: 0.5 }),
        },
      }}
    >
      {items.map((breadcrumb) => (
        <Link
          key={breadcrumb.path}
          color={
            isQuiet
              ? 'text.secondary'
              : breadcrumb.active
                ? 'text.primary'
                : 'text.secondary'
          }
          component="button"
          type="button"
          onClick={
            breadcrumb.active ? undefined : () => navigate(breadcrumb.path)
          }
          underline="hover"
          variant={isQuiet ? 'caption' : undefined}
          sx={{
            cursor: breadcrumb.active ? 'default' : 'pointer',
            fontWeight: isQuiet ? 400 : breadcrumb.active ? 600 : 400,
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            pointerEvents: breadcrumb.active ? 'none' : 'auto',
            '&:hover': {
              textDecoration: breadcrumb.active ? 'none' : 'underline',
            },
          }}
        >
          {breadcrumb.icon}
          {breadcrumb.label}
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default LayoutBreadcrumbs;
